export default __webpack_public_path__ + "static/media/brdcst_off.fafa62ba.svg";